import React, { useRef } from 'react';
import { FiImage, FiSend } from 'react-icons/fi';

const ChatInput = ({
    inputValue,
    setInputValue,
    handleSendMessage,
    handleImageSelect,
    selectedImage,
    isUploading,
    language
}) => {
    const fileInputRef = useRef(null);

    return (
        <form
            className="p-4 bg-white border-t border-gray-100 rounded-b-2xl"
            onSubmit={handleSendMessage}
        >
            {/* Selected Image Preview */}
            {selectedImage && (
                <div className="mb-3 flex items-center gap-3 p-2 bg-gray-50 rounded-lg border border-gray-100 animate-slide-up">
                    <img
                        src={URL.createObjectURL(selectedImage)}
                        alt="Preview"
                        width="40"
                        height="40"
                        className="w-10 h-10 object-cover rounded-md"
                    />
                    <div className="flex-1 min-w-0">
                        <p className="text-xs font-medium text-gray-700 truncate">{selectedImage.name}</p>
                        <p className="text-[10px] text-gray-400">Ready to send</p>
                    </div>
                    <button
                        type="button"
                        onClick={() => handleImageSelect({ target: { files: [] } })} // Clear logic needed in parent or handle here if passed
                        className="p-1 hover:bg-gray-200 rounded-full text-gray-500"
                    >
                        ×
                    </button>
                </div>
            )}

            <div className="flex items-center gap-2">
                <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden"
                    accept="image/*"
                    onChange={handleImageSelect}
                />
                <button
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                    className={`
                        p-3 rounded-xl transition-all duration-200 flex-shrink-0
                        ${selectedImage
                            ? 'bg-green-100 text-green-600'
                            : 'bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700'}
                    `}
                    title="Upload Image"
                >
                    <FiImage className="w-5 h-5" />
                </button>

                <div className="flex-1 relative">
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder={language === 'en' ? "Type your message..." : "Seidhi anuppavum..."}
                        className="w-full bg-gray-50 text-gray-800 placeholder-gray-400 border-none rounded-xl py-3 px-4 focus:ring-2 focus:ring-cherry-100 focus:bg-white transition-all outline-none"
                    />
                </div>

                <button
                    type="submit"
                    disabled={(!inputValue.trim() && !selectedImage) || isUploading}
                    className={`
                        p-3 rounded-xl flex-shrink-0 transition-all duration-300 shadow-md
                        ${(!inputValue.trim() && !selectedImage) || isUploading
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed shadow-none'
                            : 'bg-gradient-to-r from-cherry-600 to-cherry-500 text-white hover:shadow-lg hover:scale-105 active:scale-95'}
                    `}
                >
                    {isUploading ? (
                        <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                    ) : (
                        <FiSend className="w-5 h-5" />
                    )}
                </button>
            </div>
        </form>
    );
};

export default ChatInput;
